import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Modal, Button } from '@components/ui';
import CompanySelector from '@components/shared/CompanySelector';
import { gardropTurleri } from '@mocks/materials/gardrop';
import { mockCompanies } from '@mocks/firmalar';
import { calculateKDV, DEFAULT_KDV_RATE } from '@utils/kdv';
import KDVSummary from '../../components/KDVSummary';

export default function GardropModal({ isOpen, onClose, onSubmit, onMaterialSubmit, submitLabel, initialData = null, isLoading = false, insaatId }) {
    const isEdit = !!initialData;
    const [selectedCompany, setSelectedCompany] = useState(
        initialData?.supplierId ? { id: initialData.supplierId, name: initialData.tedarikci } : null
    );
    const { register, handleSubmit, reset, watch, formState: { errors } } = useForm({
        defaultValues: initialData || { siparisTarihi: new Date().toISOString().split('T')[0], tur: 'Yatak Odası Gardırop', durum: 'bekliyor', kdvOrani: DEFAULT_KDV_RATE },
    });
    const wP = watch('birimFiyat'), wQ = watch('miktar'), wV = watch('kdvOrani');

    const handleFormSubmit = (data) => {
        const r = calculateKDV({ unitPrice: data.birimFiyat, quantity: data.miktar, vatRate: data.kdvOrani });
        data.toplamFiyat = r.toplamHaric;
        data.kdvDahilToplam = r.toplamDahil;
        if (insaatId) data.insaatId = insaatId;
        data.tedarikci = selectedCompany?.name || data.tedarikci;
        data.supplierId = selectedCompany?.id || null;

        const enriched = {
            ...data,
            selectedCompany,
            calculatedTotal: data.kdvDahilToplam,
            autoDescription: `Gardrop — ${data.miktar} adet ${data.model || data.tur}`,
        };

        if (onMaterialSubmit) {
            onMaterialSubmit(enriched);
        } else {
            onSubmit(enriched, isEdit);
        }
    };

    const handleClose = () => { reset(); onClose(); };
    const inp = "w-full px-3 py-2.5 bg-bg-primary border border-border-light rounded-lg text-sm text-text-primary focus:outline-none focus:ring-2 focus:ring-primary/50";
    const err = "border-error focus:ring-error/50";

    return (
        <Modal isOpen={isOpen} onClose={handleClose} title={isEdit ? 'Kayıt Düzenle' : 'Yeni Gardırop / Dolap'} size="lg"
            footer={<><Button variant="ghost" onClick={handleClose} disabled={isLoading}>İptal</Button><Button variant="primary" onClick={handleSubmit(handleFormSubmit)} isLoading={isLoading}>{submitLabel || (isEdit ? 'Güncelle' : 'Oluştur')}</Button></>}>
            <form className="space-y-5">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <CompanySelector value={selectedCompany} onChange={setSelectedCompany} companies={mockCompanies} label="Tedarikçi / Firma" required />
                    <div><label className="block text-sm font-medium text-text-primary mb-1.5">Sipariş Tarihi</label><input type="date" {...register('siparisTarihi')} className={inp} /></div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div><label className="block text-sm font-medium text-text-primary mb-1.5">Tür <span className="text-error">*</span></label>
                        <select {...register('tur')} className={inp}>{gardropTurleri.map(t => <option key={t.key} value={t.key}>{t.label}</option>)}</select></div>
                    <div><label className="block text-sm font-medium text-text-primary mb-1.5">Model</label><input type="text" {...register('model')} placeholder="Sürgülü 240cm" className={inp} /></div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div><label className="block text-sm font-medium text-text-primary mb-1.5">Renk</label><input type="text" {...register('renk')} placeholder="Beyaz/Ceviz" className={inp} /></div>
                    <div><label className="block text-sm font-medium text-text-primary mb-1.5">Ölçü</label><input type="text" {...register('olcu')} placeholder="240x60x220 cm" className={inp} /></div>
                    <div><label className="block text-sm font-medium text-text-primary mb-1.5">Malzeme</label><input type="text" {...register('malzeme')} placeholder="MDF Lam" className={inp} /></div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div><label className="block text-sm font-medium text-text-primary mb-1.5">Blok</label><input type="text" {...register('blokAdi')} placeholder="A Blok" className={inp} /></div>
                    <div><label className="block text-sm font-medium text-text-primary mb-1.5">Durum</label><select {...register('durum')} className={inp}><option value="bekliyor">Bekliyor</option><option value="uretim">Üretimde</option><option value="teslim">Teslim</option></select></div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div><label className="block text-sm font-medium text-text-primary mb-1.5">Miktar <span className="text-error">*</span></label><input type="number" {...register('miktar', { required: true, valueAsNumber: true })} className={`${inp} ${errors.miktar ? err : ''}`} /></div>
                    <div><label className="block text-sm font-medium text-text-primary mb-1.5">Birim Fiyat (₺)</label><input type="number" {...register('birimFiyat', { valueAsNumber: true })} className={inp} /></div>
                    <div><label className="block text-sm font-medium text-text-primary mb-1.5">KDV (%)</label><input type="number" {...register('kdvOrani', { valueAsNumber: true })} className={inp} /></div>
                </div>
                <KDVSummary unitPrice={wP} quantity={wQ} vatRate={wV} />
                <div><label className="block text-sm font-medium text-text-primary mb-1.5">Not</label><textarea {...register('not')} rows={2} placeholder="Kayıt notu..." className={`${inp} resize-none`} /></div>
            </form>
        </Modal>
    );
}
